import i18n from '../../i18n';
import {
  stateName,
  getTranslatedStateNameList,
  getStateCodeStateNameByIndex,
} from '../../utils/stateCode';
import CustomDropdown from '../custom_dropdown/CustomDropdown';

import {Button} from '@deere/ux.uxframe-react';
import './OfferModal.css';
import PropTypes from 'prop-types';
import React from 'react';

const OfferModal = (props) => {
  const [selectedState, setSelectedState] = React.useState('');
  const [optionIndex, setOptionIndex] = React.useState(null);
  const [isCorporate, setIsCorporate] = React.useState(false);

  const option = getTranslatedStateNameList();
  return (
    <div>
      <div className="selectState">
        {props.bodyContent}
        <span id="asterisk">*</span>
      </div>
      <CustomDropdown
        placeHolder={i18n.t('PLEASE_SELECT')}
        className="custom_dropdown"
        options={option}
        selectOption={(value, index) => {
          setSelectedState(value);
          setOptionIndex(index);
        }}
        title={true}
        selectedValue={optionIndex}
        classNameSuffix={'offerDropdownSuffix'}
        classNameB={'offerDropdownBtn'}
        classNameDpdn={'offerDropdownOption'}
      />

      <Button
        className={`${props.modalBtnClass ? props.modalBtnClass : ''}`}
        id="submitButton"
        variant="primary"
        disabled={!selectedState}
        onClick={() => {
          props?.onSubmitModel({
            state: stateName[optionIndex],
            isCorporate: isCorporate,
            i18nName: selectedState,
            stateCode: getStateCodeStateNameByIndex(optionIndex),
          });
        }}
      >
        {props.btnName ? i18n.t(props.btnName) : i18n.t('SUBMIT')}
      </Button>
    </div>
  );
};

OfferModal.propTypes = {
  bodyContent: PropTypes.node,
  modalBtnClass: PropTypes.string,
  onSubmitModel: PropTypes.func,
  btnName: PropTypes.string,
};

export default OfferModal;
